<h1 mat-dialog-title>Want to Join Meeting ? </h1>
<mat-dialog-content>
    <div class="pb-4">
        <app-org-bu-project-team-structure
                [placeHolder]="'Select Entity*'"
                [label]="'Entity'"
                [dynamicClasses]="'csf'"
                [dataForTree]="this.dataSource"
                [appearance]="'fill'"
                [isApplySelectableFilter]="true"
                [isAllowedToReset]="false"
                [selectedEntityName]="selectedEntityName"
                [selectedEntityInfo]="selectedEntityInfo"
                (selectedEntityChange)="handleSelectedEntityNew($event)"
        ></app-org-bu-project-team-structure>
    </div>

    <!-- Meeting Room -->
    <mat-form-field appearance="fill" class="csf">
        <mat-label>Meeting Room</mat-label>
        <input matInput
               id="meetingNameInputId"
               [(ngModel)]="meetingName"
               (ngModelChange)="onMeetingNameChange(meetingName)"
               required>
        <mat-hint *ngIf="isMeetingNameInvalid">
            Room name must be alphanumeric.
            Use <b>_</b> instead of spaces.
        </mat-hint>
    </mat-form-field>

    <!-- Duration -->
    <mat-form-field appearance="fill" class="csf" *ngIf="!isMeetingActive">
        <mat-label>Duration<sup>(In min)</sup></mat-label>
        <input matInput [(ngModel)]="duration" type="number" min="1"  [max]="maxDuration || null" required>
        <mat-hint *ngIf="maxDuration">
            Max {{ maxDuration }} minutes (next meeting scheduled)
        </mat-hint>
    </mat-form-field>

    <!-- Title -->
    <mat-form-field appearance="fill" class="csf">
        <mat-label>Title</mat-label>
        <input matInput
               required
               [minlength]="MEETING_VALIDATION_CONSTANTS.MEETING_TITLE_MIN_LENGTH"
               [maxLength]="MEETING_VALIDATION_CONSTANTS.MEETING_TITLE_MAX_LENGTH"
               [(ngModel)]="meetingTitle">
        <mat-hint align="end">{{ meetingTitle?.length || 0 }}/ {{MEETING_VALIDATION_CONSTANTS.MEETING_TITLE_MAX_LENGTH}}</mat-hint>
    </mat-form-field>

    <div class="scheduled-info"
         *ngIf="isMeetingScheduledToday && scheduledMeetingTimeText">
        <p class="ff-medium">
            {{ scheduledMeetingTimeText }}
        </p>
    </div>

    <div class="avatars" *ngIf="attendees.length > 0 || organizer">
        <!-- Organizer -->
        <div class="d-flex" *ngIf="organizer" matTooltip="{{ organizer.name }}">
            <lucide-icon *ngIf="!organizer.image"
                         size="24"
                         class="attendees-icon"
                         name="circle-user-round"></lucide-icon>

            <img *ngIf="organizer.image"
                 [src]="organizer.image"
                 alt="{{ organizer.name }}"
                 class="attendees-icon"/>

            <span class="host-text ff-medium"><p>Host</p></span>
        </div>

        <!-- Attendees -->
        <div *ngFor="let attendee of attendeesToShowWithProfileView"
             matTooltip="{{ attendee.name }}">
            <lucide-icon *ngIf="!attendee.image"
                         size="24"
                         name="circle-user-round"></lucide-icon>

            <img *ngIf="attendee.image"
                 [src]="attendee.image"
                 alt="{{ attendee.name }}"
                 class="attendees-icon"/>
        </div>

        <!-- +N -->
        <span class="more-attendees ff-medium"
              *ngIf="additionalAttendeesCount > 0"
              matTooltip="{{ getAttendeeNamesTooltip() }}">
            <p>+{{ additionalAttendeesCount }}</p>
        </span>
    </div>

</mat-dialog-content>
<mat-dialog-actions class="d-flex justify-content-end align-items-center gap-1">
    <button mat-flat-button (click)="closeDialog()">Close</button>
    <button *ngIf="isMeetingActive" [disabled]="isJoinMeetingDisabled()" [class.disabled]="isJoinMeetingDisabled()" (click)="joinMeeting()"
            class="tse-btn-primary" id="getMeetingNameBtnId">Join Meeting
    </button>

    <button *ngIf="!isMeetingActive" [disabled]="isCreateMeetingDisabled()" [class.disabled]="isCreateMeetingDisabled()" (click)="createNewMeeting()" class="tse-btn-primary" id="getMeetingNameBtnId">
        Create Meeting
    </button>
</mat-dialog-actions>
